/* @flow */

import * as React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash/fp';

const orderByTimestamp = orderBy('timestamp', 'desc');

type Props = {
  children: any,
};

type Listener = (Array<Object>) => void;

class NotificationsProvider extends React.Component<Props> {
  props: Props;
  listeners: Set<Listener> = new Set(); // eslint-disable-line react/sort-comp
  notifications: Map<string, Object> = new Map();

  static childContextTypes = {
    notifications: PropTypes.shape({
      add: PropTypes.func.isRequired,
      remove: PropTypes.func.isRequired,
      subscribe: PropTypes.func.isRequired,
      unsubscribe: PropTypes.func.isRequired,
    }).isRequired,
  };

  getChildContext() {
    return {
      notifications: {
        add: this.addNotification,
        remove: this.removeNotification,
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
      },
    };
  }

  emit() {
    const notificationsArray = orderByTimestamp(Array.from(this.notifications.values()));

    this.listeners.forEach(listener => listener(notificationsArray));
  }

  addNotification = (id: string, notification: Object) => {
    const prevNotification = this.notifications.get(id);

    if (prevNotification) {
      this.notifications.set(id, {
        ...prevNotification,
        ...notification,
      });
    } else {
      this.notifications.set(id, {
        id,
        ...notification,
        timestamp: Date.now(),
      });
    }

    this.emit();
  };

  removeNotification = (id: string) => {
    const notification = this.notifications.get(id);
    if (notification && notification.onClose) {
      notification.onClose();
    }
    this.notifications.delete(id);
    this.emit();
  };

  subscribe = (listener: Listener) => {
    this.listeners.add(listener);
  };

  unsubscribe = (listener: Listener) => {
    this.listeners.delete(listener);
  };

  render() {
    return this.props.children;
  }
}

export default NotificationsProvider;
